module.exports = __webpack_public_path__ + "static/media/economics.8ba1a4c9.webp";